function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSezione04Popup01Ico02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.41 65.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.41,51c0,3.07-2.49,5.56-5.56,5.56s-5.56-2.49-5.56-5.56,2.49-5.56,5.56-5.56,5.56,2.49,5.56,5.56Z",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51,64.9c0-4.61,3.73-8.34,8.34-8.34s8.34,3.73,8.34,8.34",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.05,51c0,3.07-2.49,5.56-5.56,5.56s-5.56-2.49-5.56-5.56,2.49-5.56,5.56-5.56,5.56,2.49,5.56,5.56Z",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.14,64.9c0-4.61,3.73-8.34,8.34-8.34s8.34,3.73,8.34,8.34",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.68,51c0,3.07-2.49,5.56-5.56,5.56s-5.56-2.49-5.56-5.56,2.49-5.56,5.56-5.56,5.56,2.49,5.56,5.56Z",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.19,39.88h40.31c2.3,0,4.17-1.87,4.17-4.17V5.12c0-2.3-1.87-4.17-4.17-4.17H12.07M53.78,64.9c0-4.61,3.73-8.34,8.34-8.34s8.34,3.73,8.34,8.34",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.12,13.46c0,3.07,2.49,5.56,5.56,5.56s5.56-2.49,5.56-5.56-2.49-5.56-5.56-5.56-5.56,2.49-5.56,5.56Z",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinejoin: "round",
      strokeWidth: "1.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.75,12.07h13.9M28.75,6.51h13.9M42.66,25.97v8.34M59.34,12.07v22.24M48.22,16.24v18.07M53.78,21.8v12.51M.95,39.87v-11.12c0-5.18,2.82-8.34,9.73-8.34h20.85c1.54,0,2.78,1.24,2.78,2.78s-1.24,2.78-2.78,2.78h-11.12c-1.54,0-2.78,1.25-2.78,2.78v11.12",
    style: {
      fill: "none",
      stroke: "#0a2651",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.9px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSezione04Popup01Ico02);
export default __webpack_public_path__ + "static/media/sezione-04-popup-01-ico-02.1a7cdab1d79a84639805deb0b6a25efb.svg";
export { ForwardRef as ReactComponent };